import actionTypes from "consts/actionTypes.js";

const initialState = {
  weCareID: undefined,
  userMaterials: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_WECAREID:
      return {
        ...state,
        weCareID: action.value,
      };
    case actionTypes.SET_USER_MATERIALS:
      return {
        ...state,
        userMaterials: action.value,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/session.js